module.exports = __webpack_public_path__ + "media/images/japan/polaroid_frame-161baa53176212e3b3cecbc81a11163a.png";